import { Text } from '@adobe/react-spectrum';
import ChevronRight from '@spectrum-icons/workflow/ChevronRight';
import React from 'react';
import { GridListItem } from 'react-aria-components';
import styled from 'styled-components';

import { WithSkeleton } from '@exchange-frontends/components';

/**
 * styled react-spectrum ListItem component for the HelpSupportList
 * @memberof HelpSupportListItem
 * @type {styled-component}
 */
const HelpSupportListItem = styled(GridListItem)`
  cursor: pointer;
  display: flex;
  padding: 24px;
  border-bottom: var(--spectrum-alias-border-size-thin) solid var(--spectrum-global-color-gray-200);
  :last-child {
    border-bottom: none;
  }
  :hover {
    background-color: rgba(44, 44, 44, 0.04);
  }
`;

/**
 * styled span container for HelpSupportListItemContent
 * @memberof HelpSupportListItem
 * @type {styled-component}
 */
const HelpSupportListItemContentContainer = styled.span`
  flex: 1 1 auto;
  line-height: 1.3;
  overflow-wrap: break-word;
  width: calc(100% - 24px);
`;

/**
 * styled span for HelpSupportList
 * @memberof HelpSupportListItem
 * @type {styled-component}
 */
const HelpSupportListItemContent = styled.span`
  display: flex;
  justify-content: space-between;
  span {
    font-weight: bold;
    color: var(--spectrum-global-color-gray-900);
  }
`;

/**
 * Help Support Grid List item, renders HelpSupportListItem component children
 * @prop {string} aria-label - text aria label string for list item
 * @prop {component(s)} children - child HelpListItem components to render
 */
const HelpSupportGridListItem = ({ icon, label, loading = false, extraLoadings = false, dataLaunchId, onClick }) => {
  return (
    <HelpSupportListItem onAction={onClick} aria-label={label}>
      {icon}
      <HelpSupportListItemContentContainer>
        <HelpSupportListItemContent>
          <Text data-launchid={dataLaunchId} marginStart="size-100">
            <WithSkeleton shouldRender={!loading && !extraLoadings} width={200}>
              {label}
            </WithSkeleton>
          </Text>
          <ChevronRight size="S" />
        </HelpSupportListItemContent>
      </HelpSupportListItemContentContainer>
    </HelpSupportListItem>
  );
};

export default HelpSupportGridListItem;
